var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9359 4.1595L14.0009 1.2095C13.8069 1.01653 13.5445 0.908203 13.2709 0.908203C12.9973 0.908203 12.7348 1.01653 12.5409 1.2095L2.13588 11.5995L1.18588 15.6995C1.15311 15.8494 1.15423 16.0047 1.18917 16.1541C1.22411 16.3035 1.29197 16.4432 1.38781 16.563C1.48365 16.6828 1.60505 16.7796 1.74312 16.8465C1.8812 16.9134 2.03247 16.9486 2.18588 16.9495C2.25737 16.9567 2.3294 16.9567 2.40088 16.9495L6.54588 15.9995L16.9359 5.6195C17.1288 5.42555 17.2372 5.16309 17.2372 4.8895C17.2372 4.61591 17.1288 4.35344 16.9359 4.1595ZM6.04588 15.0995L2.16088 15.9145L3.04588 12.1045L10.8309 4.3495L13.8309 7.3495L6.04588 15.0995ZM14.5009 6.6245L11.5009 3.6245L13.2409 1.8945L16.1909 4.8945L14.5009 6.6245Z",
    fill: "#4E5D78"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.c2969c65124c6d29670d84e3c9a68e07.svg";
export { ForwardRef as ReactComponent };